import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE_URL = "https://pastaluna.co.il";
const DEFAULT_TITLE = "PastaLuna | פסטה איטלקית ללא גלוטן, טבעונית ועשירה בחלבון";
const DEFAULT_DESC = "פסטה לונה (PastaLuna) פסטה איטלקית איכותית ללא גלוטן, 100% טבעונית ועשירה בחלבון. חוויה קולינרית בריאה ומזינה בכל ביס. היכנסו לאתר למגוון המוצרים.";
const DEFAULT_IMAGE = `${SITE_URL}/og-image.jpg`;

const upsertMeta = (key: "name" | "property", value: string, content: string) => {
  let el = document.head.querySelector(`meta[${key}="${value}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(key, value);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const upsertLink = (rel: string, href: string) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`) as HTMLLinkElement | null;
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

/**
 * Sets sensible default SEO tags on every route change so any new page
 * gets a canonical URL and og:url automatically. Per-page <SEO /> components
 * mounted later in the tree override these defaults.
 */
const RouteSEO = () => {
  const location = useLocation();

  useEffect(() => {
    const url = `${SITE_URL}${location.pathname}`;
    // Reset to defaults; per-page <SEO /> will overwrite immediately if present.
    document.title = DEFAULT_TITLE;
    upsertMeta("name", "description", DEFAULT_DESC);
    upsertMeta("property", "og:title", DEFAULT_TITLE);
    upsertMeta("property", "og:description", DEFAULT_DESC);
    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:image", DEFAULT_IMAGE);
    upsertMeta("property", "og:site_name", "PastaLuna");
    upsertMeta("property", "og:locale", "he_IL");
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", DEFAULT_TITLE);
    upsertMeta("name", "twitter:description", DEFAULT_DESC);
    upsertMeta("name", "twitter:image", DEFAULT_IMAGE);
    upsertLink("canonical", url);
  }, [location.pathname]);

  return null;
};

export default RouteSEO;
